import { render, staticRenderFns } from "./Authen.vue?vue&type=template&id=064aad61&scoped=true"
import script from "./Authen.vue?vue&type=script&lang=js"
export * from "./Authen.vue?vue&type=script&lang=js"
import style0 from "./Authen.vue?vue&type=style&index=0&id=064aad61&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064aad61",
  null
  
)

export default component.exports